import { render, staticRenderFns } from "./AdminServiceHintsOverview.vue?vue&type=template&id=47108ef4&scoped=true"
import script from "./AdminServiceHintsOverview.vue?vue&type=script&lang=js"
export * from "./AdminServiceHintsOverview.vue?vue&type=script&lang=js"
import style0 from "./AdminServiceHintsOverview.vue?vue&type=style&index=0&id=47108ef4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47108ef4",
  null
  
)

export default component.exports